import { render, staticRenderFns } from "./workbench.vue?vue&type=template&id=136a7998&"
import script from "./workbench.vue?vue&type=script&lang=js&"
export * from "./workbench.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/common.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports